export const getPreselectedSteps = (
  p_uc,
  structureTypesMapping,
  PermitTypeId,
  getOptions
) => {
  const result = {
    miniMap: [PermitTypeId],
    formSelections: {},
  };

  const map = structureTypesMapping?.[p_uc];
  if (!map || !Array.isArray(map)) return { result, autoSelectSkipped: true };

  const [, proposedList, structureId] = map;

  const proposedOptions = getOptions("ProposedUseId", [PermitTypeId], {});
  const validProposed = proposedOptions.find((opt) =>
    proposedList.includes(opt.id)
  );

  if (!validProposed) return { result, autoSelectSkipped: true };

  result.formSelections["ProposedUseId"] = validProposed.id;
  result.miniMap.push(validProposed.id);

  const structureOptions = getOptions(
    "StructureTypeId",
    [PermitTypeId, validProposed.id],
    { ProposedUseId: validProposed.id }
  );
  const validStructure = structureOptions.find((opt) => opt.id === structureId);

  if (!validStructure) return { result, autoSelectSkipped: true };

  result.formSelections["StructureTypeId"] = validStructure.id;
  result.miniMap.push(validStructure.id);

  return { result, autoSelectSkipped: false };
};
